<template>
	<div class="detail-view hit">
		<included-hitch-page></included-hitch-page>
	</div>
</template>

<script>
import IncludedHitchPage from "../components/pages/IncludedHitchPage";
export default {
  name: "IncludedHitch",
  components: {IncludedHitchPage},
}
</script>


<style lang="scss">
.detail-view {
  &.hit {
    .product-detail {
      top: 27vh;
    }
  }
}
</style>
